import clientAxios from '../clients/clientAxios';
import { STUDENTS, SMARTTHINGS_SCENES, DEFAULT_PAGE_SIZE } from '../config/apiRoutes';

export const getStudents = async ({ page = 1, pageSize = DEFAULT_PAGE_SIZE, query } = {}) => {
  const params = { page, pageSize };
  if (query) {
    params.query = JSON.stringify(query);
  }
  const { data } = await clientAxios.get(STUDENTS, { params });
  return data;
};

export const toggleSmartThingsScene = async (sceneName) => {
  const { data } = await clientAxios.post(SMARTTHINGS_SCENES, { sceneName });
  return data;
};

export const createStudent = async (studentPayload) => {
  const { data } = await clientAxios.post(STUDENTS, studentPayload);
  return data;
};
